import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutAvailableTractorList extends Layout {
    layoutheaderAvailableTractors: LayoutHeader;
    sourceAvailTractDetail: DataSource;
    tableAddedTractors: Table;
}
